import { isGlobalDomain } from '@config/globalDomain';

import { ProjectName } from '../interfaces';

const getProjectName = (): ProjectName => (isGlobalDomain ? 'epncpa' : 'epn');

export default getProjectName;
